<template>
  <div class="events-requests">
    <div class="cities">
      <span v-for="place in eventCities" class="city-wrapper" @click="handleGetEventCity(place.id)">
        <span :key="place.id"
          :class="selectedCity && selectedCity.id === place.id ? 'is-active' : '' "
          class="city-title">{{place.name}}
        </span>
      </span>
    </div>
    <div class="events columns is-multiline" v-if="selectedCity">
      <div class="event-wrapper column is-half"
      v-for="event in selectedCity.events" :key="event.id">
        <div class="event centered">
          <span class="link" @click="showParticipants" :id='event.id' ref="event.id" v-if="event.eventParticipants.length">
            Посмотреть {{ event.eventParticipants.length }} зарегистровавшихся
          </span>
          <span>{{event.date | filterDate}} <br></span>
          <span class="event-title">{{event.title}} <br></span>
          <span>{{event.description}} <br></span>
        </div>
      </div>
    </div>
    <el-dialog v-if="event" class="event-dialog"
      :visible.sync="dialogVisible"
      >
      <div class="event-participants">
        <span>
          {{ event.title }}
        </span>
        <span>
          {{ event.date }}
        </span>
        <span class="event-participants-count">
          {{event.eventParticipants.length}}
        </span>
        <table class="participants-table">
          <tr v-for="participant in event.eventParticipants">
            <td class="name"> {{ participant.surname }} <br> {{ participant.name }} {{ participant.patronymic}}</td>
            <td class="commpany-name"> {{ participant.companyName }}</td>
            <td> {{ participant.phone }}</td>
            <td> {{ participant.email }}</td>
          </tr>
        </table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import deepcopy from 'deepcopy'

export default {
  name: 'EventsRequests',
  data () {
    return {
      selectedCity: null,
      activeTab: null,
      event: null,
      dialogVisible: false
    }
  },
  created () {
    this.getEventsPlaces()
  },
  computed: {
    ...mapState(['eventCities'])
  },
  methods: {
    ...mapActions(['getEventsPlaces']),
    handleGetEventCity (id) {
      this.selectedCity = this.eventCities.find(e => e.id === id)
    },
    showParticipants (ev) {
      const id = ev.target.id
      this.event = deepcopy(this.selectedCity.events.find(e => e.id === id))
      this.event.date = this.event.date ? moment(this.event.date).format('LLL') : ''
      this.dialogVisible = true
      ev.preventDefault()
    }
  },
  filters: {
    filterDate (date) {
      if (date) {
        const d = new Date(date)
        return `${d.getFullYear()}/${d.getMonth() + 1}/${d.getDate()}`
      }
    }
  },
  watch: {
    eventCities (val) {
      this.selectedCity = val[0]
    }
  }
}
</script>
<style scoped>
.events-cities {
  margin: 20px 0 30px;
}
.cities {
  margin-top: 8px;
}
.events {
  margin: 20px auto 40px;
  max-width: 1400px;
}
.event {
  background: #eee;
  padding: 100px;
  color: black;
  flex-direction: column;
}
.event span {
  margin: 3px 0;
}
.event-title {
  font-weight: bold;
  font-size: 16px;
}
.event-participants > span {
  display: block;
  text-align: center;
}
.event-participants-count {
  font-weight: bold;
  margin: 5px 0;
  font-size: 1.4em;
}
.participants-table tr {
  border: 1px solid lightgray;
  border-radius: 5px;
  margin: 10px 0;
  display: block;
}
.participants-table td {
  padding: 8px 14px;
}
.participants-table .commpany-name {
  min-width: 180px;
}
.participants-table .name {
  min-width: 155px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// EventsRequests.vue?161db609